module.exports = __webpack_public_path__ + "static/media/marker-se.8599ae03.svg";